import { currencyConfigApi, rewardConfigApi } from '../store/api/knowledge-operation';
import { recommendSwitch } from '../store/api/recommend';
import { getRuleConfigApi } from '../store/api/global';

let isRequesting = false;

export default async (store, routePath) => {
    const pathList = [
        '/center',
        '/share-study',
        '/share-content-detail',
        '/share-team',
        '/publish-manage',
        '/column-manage',
        '/learncoin-manage',
        '/member-manage',
        '/output-detail',
    ];
    const isPass = pathList.some(r => routePath.includes(r));
    if (!isPass || isRequesting) return;
    isRequesting = true;
    // 获取学币名称配置
    if (store.state.app.currencyName === null) {
        const { data } = await currencyConfigApi();
        let currencyName = '学币';
        try {
            currencyName = JSON.parse(data.value).currencyName;
        } catch (error) {
            console.error('学币配置json解析失败');
        }
        store.commit('setCurrencyName', currencyName);
    }
    // 页面渲染前先获取打赏配置
    if (store.state.app.rewardConfig === null) {
        const rewardConfig = await rewardConfigApi();
        store.commit('setRewardConfig', (rewardConfig && rewardConfig.data) || {});
    }
    // 页面渲染前先获取是否开启了达观算法
    if (store.state.app.daGuanStatus === null) {
        const res = await recommendSwitch();
        store.commit('setDaGuanStatus', res && res.data && res.data.result);
    }
    // 获取分享配置
    const shareConfig = window.sessionStorage.getItem('share-config');
    if (!shareConfig) {
        const config = await getRuleConfigApi({ key: 'SHARE_CONFIG' });
        window.sessionStorage.setItem(
            'share-config',
            JSON.stringify((config && config.data) || {})
        );
    }
    isRequesting = false;
};
